export default {
  baseURL: "https://ushoutai.truelovecity.com", // 五龙空降刷单-正式环境
};
